import 'vite/modulepreload-polyfill'

function callbackDoReflow(ktable, index) {
    if (typeof ktable != 'undefined') {
        ktable.doReflow(index);
    }
}

window.addEventListener('DOMContentLoaded', function () {
    let ktableSpiele;
    let ktableFragen;
    let ktableRennen;
    const tabelleSpiele = $("#spiele");
    if (tabelleSpiele.length) {
        ktableSpiele = tabelleSpiele.ktable().data('ktable');
        ktableSpiele.hide(['wettbewerb']);
        ktableSpiele.hide(['gruppe']);
        ktableSpiele.hide(['punkteregel']);
        ktableSpiele.hide(['tipptermin']);
        ktableSpiele.rowheader(['termin'],
            {
                reflowCallback: function () {
                    callbackDoReflow(ktableSpiele, 0);
                }
            });
        ktableSpiele.shrink(['heim', 'gast']);
        ktableSpiele.stack(['heim', 'gast']);
        ktableSpiele.overflow(['heim']);
        ktableSpiele.prepare();
        ktableSpiele.reflow();
    }
    const tabelleFragen = $("#fragen");
    if (tabelleFragen.length) {
        ktableFragen = tabelleFragen.ktable().data('ktable');
        ktableFragen.hide(['wettbewerb']);
        ktableFragen.hide(['punkteregel']);
        ktableFragen.hide(['tipptermin']);
        ktableFragen.rowheader(['termin'],
            {
                reflowCallback: function () {
                    callbackDoReflow(ktableSpiele, 0);
                }
            });
        ktableFragen.stack(['frage', 'ergebnis']);
        ktableFragen.wrap(['frage']);
        ktableFragen.prepare();
        ktableFragen.reflow();
    }
    const tabelleRennen = $("#rennen");
    if (tabelleRennen.length) {
        ktableRennen = tabelleRennen.ktable().data('ktable');
        ktableRennen.hide(['sichtbarkeitsregel']);
        ktableRennen.hide(['wettbewerb']);
        ktableRennen.hide(['punkteregel']);
        ktableRennen.hide(['tipptermin']);
        ktableRennen.rowheader(['termin'],
            {
                reflowCallback: function () {
                    callbackDoReflow(ktableSpiele, 0);
                }
            });
        ktableRennen.stack(['name', 'ergebnis']);
        ktableRennen.wrap(['name']);
        ktableRennen.prepare();
        ktableRennen.reflow();
    }
});
